"use client";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { useEffect } from "react";
import { IsTopWinner } from "@/utils/functions/global-constants";
import { ICompany } from "@/api/AppApi/services/company/interfaces/ICompany";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useLang } from "@/providers/langProvider";
interface Props {
  mobile?: boolean;
  company: ICompany;
}
const StudentsDashboardBtn: React.FC<Props> = ({ mobile, company }) => {
  const router = useRouter();
  const t = useTranslation();
  const topWinner = IsTopWinner(company);
  const lang = useLang();
  useEffect(() => {
    router.prefetch(`/${lang}${PagesPaths.students}`);
  }, [router]);
  return (
    <button
      className={`${mobile ? "signin-btn-mobile" : "pc-signin-btn"}`}
      onClick={() => {
        router.push(topWinner ? PagesPaths.agentsForms : PagesPaths.students);
      }}
    >
      {topWinner ? t.agents_forms_dashboard : t.students_dashboard}
    </button>
  );
};

export default StudentsDashboardBtn;
